// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Ffe9","actionsCol":"EnrolledClinics_actionsCol__5JaNR"};